import React from 'react'

import {
  InternalLink,
} from '../../styles/links'
import {
  YellowWell,
} from '../../styles/wells'

const UpsellWell = () => (
  <YellowWell>
    <p>Subscribers can add unlimited people, sort them into groups, star VIPs, and more.</p>
    <InternalLink to={`/account`}>See all premium features</InternalLink>
  </YellowWell>
)

export default UpsellWell



// WEBPACK FOOTER //
// ./src/views/people/UpsellWell.js